export const DAILY_TARGETS_CHANGED_EVENT = "daily-targets-changed";
const BROADCAST_CHANNEL = "naseebi-daily-targets";

/**
 * @param {{ team?: string, targetDate?: string }} [detail]
 */
export function notifyDailyTargetsChanged(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(DAILY_TARGETS_CHANGED_EVENT, { detail }));
  try {
    const bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.postMessage(detail);
    bc.close();
  } catch {
    // BroadcastChannel not available in some environments.
  }
}

export function subscribeDailyTargetsChanged(handler) {
  if (typeof window === "undefined") return () => {};

  const onWindow = (event) => handler(event?.detail || {});
  window.addEventListener(DAILY_TARGETS_CHANGED_EVENT, onWindow);

  let bc = null;
  try {
    bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.onmessage = (event) => handler(event?.data || {});
  } catch {
    // ignore
  }

  return () => {
    window.removeEventListener(DAILY_TARGETS_CHANGED_EVENT, onWindow);
    if (bc) {
      bc.onmessage = null;
      bc.close();
    }
  };
}
